var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#E6007A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9972 7.56774C16.166 7.56774 17.9241 6.54522 17.9241 5.28387C17.9241 4.02252 16.166 3 13.9972 3C11.8284 3 10.0703 4.02252 10.0703 5.28387C10.0703 6.54522 11.8284 7.56774 13.9972 7.56774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9972 24.7762C16.166 24.7762 17.9241 23.7537 17.9241 22.4924C17.9241 21.231 16.166 20.2085 13.9972 20.2085C11.8284 20.2085 10.0703 21.231 10.0703 22.4924C10.0703 23.7537 11.8284 24.7762 13.9972 24.7762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52726 10.729C9.61164 8.85081 9.6046 6.81666 8.51154 6.18556C7.41847 5.55446 5.6533 6.56539 4.56892 8.44354C3.48454 10.3217 3.49157 12.3558 4.58464 12.9869C5.6777 13.618 7.44287 12.6071 8.52726 10.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4269 19.3324C24.5113 17.4542 24.5049 15.4204 23.4125 14.7898C22.3202 14.1591 20.5556 15.1704 19.4713 17.0485C18.3869 18.9267 18.3933 20.9605 19.4856 21.5912C20.578 22.2218 22.3425 21.2105 23.4269 19.3324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51154 21.5903C9.6046 20.9592 9.61164 18.9251 8.52726 17.0469C7.44287 15.1688 5.6777 14.1578 4.58464 14.7889C3.49157 15.42 3.48453 17.4542 4.56892 19.3323C5.6533 21.2105 7.41847 22.2214 8.51154 21.5903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4125 12.9876C24.5049 12.3569 24.5113 10.3231 23.4269 8.44495C22.3425 6.5668 20.578 5.55552 19.4856 6.18619C18.3933 6.81686 18.3869 8.85067 19.4713 10.7288C20.5556 12.607 22.3202 13.6183 23.4125 12.9876Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4776,
    height: 21.7778,
    fill: "white",
    transform: "translate(3.76172 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyDot);
export default __webpack_public_path__ + "static/media/Currency=DOT.0f0701103f6d3dd101418b8ae713432e.svg";
export { ForwardRef as ReactComponent };